import React from 'react'
import styled from 'styled-components'
import { DSText } from '@zoe/ds-web'
import { SOCIAL_PROOF } from '../../../data/socialProof'

// Figma "Social proof / Ratings row": app rating | divider | monthly users
// between laurels. The numbers live in SOCIAL_PROOF.

const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
`

const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  text-align: center;
  white-space: nowrap;
`

const Label = styled.span`
  font-family: 'LotaGrotesqueAlt1-Regular', sans-serif;
  font-size: 11px;
  line-height: 16.8px;
  letter-spacing: 0.55px;
  text-transform: uppercase;
  color: var(--colour-text-placeholder);
`

const Stars = styled.span`
  display: flex;
  gap: 1.5px;
`

const Star = styled.img<{ $empty?: boolean }>`
  width: 18px;
  height: 18px;
  ${({ $empty }) => ($empty ? 'opacity: 0.2;' : '')}
`

const Divider = styled.div`
  width: 1px;
  height: 44px;
  background: var(--color-border-default);
`

const Laurels = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`

const Laurel = styled.img<{ $flip?: boolean }>`
  width: 15px;
  height: 29px;
  ${({ $flip }) => ($flip ? 'transform: scaleX(-1);' : '')}
`

const MAX_STARS = 5

const StarRating: React.FC<{ rating: number }> = ({ rating }) => {
  const full = Math.floor(rating)
  return (
    <Stars role="img" aria-label={`Rated ${rating} out of ${MAX_STARS}`}>
      {Array.from({ length: MAX_STARS }, (_, i) => {
        if (i < full) return <Star key={i} src="/img/shared/star.svg" alt="" />
        if (i === full && rating > full) return <Star key={i} src="/img/shared/star-partial.svg" alt="" />
        return <Star key={i} src="/img/shared/star.svg" alt="" $empty />
      })}
    </Stars>
  )
}

export const RatingsRow: React.FC = () => (
  <Row>
    <Column style={{ width: 135 }}>
      <Label>{SOCIAL_PROOF.appRatingsCount} App ratings</Label>
      <DSText variant="fluid-paragraph-400" weight="semiBold" as="span">
        {SOCIAL_PROOF.appRating}
      </DSText>
      <StarRating rating={SOCIAL_PROOF.appRating} />
    </Column>
    <Divider aria-hidden="true" />
    <Laurels>
      <Laurel src="/img/shared/laurel.svg" alt="" />
      <Column>
        <Label>Trusted by over</Label>
        <DSText variant="fluid-paragraph-400" weight="semiBold" as="span">
          {SOCIAL_PROOF.monthlyUsers}
        </DSText>
        <Label>every month</Label>
      </Column>
      <Laurel src="/img/shared/laurel.svg" alt="" $flip />
    </Laurels>
  </Row>
)
